import { get } from '../../index';

export const createdDaily = (type, dateSlice) => {
  return get(`admin/report/${type}/${dateSlice}`);
};